import { render, staticRenderFns } from "./FactoryCommercialSignage.vue?vue&type=template&id=3d172b27&scoped=true&"
import script from "./FactoryCommercialSignage.vue?vue&type=script&lang=ts&"
export * from "./FactoryCommercialSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d172b27",
  null
  
)

export default component.exports